import { Statistics } from '../../pages';
import { Prompts, PromptsForCampaign } from '../../pages';
import { Messages, MessagesForContact } from '../../pages';
import { Contacts, ContactsImport, Webhooks } from '../../pages';
import { Tasks, Campaigns, CampaignMonitoring } from '../../pages';

const mainMenuRoutes: AppRouteType[] = [
  {
    icon: 'list',
    url: '/tasks',
    menuTitle: 'Tasks',
    pageTitle: 'Tasks Management',

    component: Tasks,
  },
  {
    icon: 'rocket',
    url: '/campaigns',
    menuTitle: 'Campaigns',
    pageTitle: 'Campaigns Management',

    component: Campaigns,
  },
  {
    icon: 'eye',
    url: '/campaign_monitoring',
    menuTitle: 'Campaign Monitoring',

    component: CampaignMonitoring,
  },
  {
    icon: 'people',
    url: '/contacts_management',
    menuTitle: 'Contacts',
    pageTitle: 'Contacts Management',

    component: Contacts,
  },
  {
    icon: 'plus',
    url: '/contacts_import',
    menuTitle: 'Import Contacts',

    component: ContactsImport,
  },
  {
    url: '/messages_history/:id',
    pageTitle: 'Messages History',

    component: MessagesForContact,
  },
  {
    icon: 'messages',
    url: '/messages_history',
    menuTitle: 'Messages',
    pageTitle: 'Messages Contacts',

    component: Messages,
  },
  {
    icon: 'hook',
    url: '/webhook_events',
    menuTitle: 'Webhook Events',

    component: Webhooks,
  },

  {
    url: '/system_prompts/:id',
    pageTitle: 'System Prompts List',

    component: PromptsForCampaign,
  },
  {
    icon: 'document',
    url: '/system_prompts',
    menuTitle: 'Prompts',
    pageTitle: 'System Prompts',

    component: Prompts,
  },
  {
    icon: 'chart',
    url: '/system_statistics',
    menuTitle: 'Statistics',
    pageTitle: 'System Statistics',

    component: Statistics,
  },
];

export const getRoutes: (meta: AppMetaType) => AppRouteType[] = _meta => {
  return mainMenuRoutes;

  // return [
  //   {
  //     groupTitle: 'Main Menu',
  //     routes: mainMenuRoutes,
  //   },
  // ];
};
